// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__NIUoQ","labelContainer":"styles_labelContainer__SxhOm","label":"styles_label__3V4FI","buttonsContainer":"styles_buttonsContainer__opwHf"};